/** Shared tier-0 welcome / blocked-hub messaging (unlock card + rewards hub). */
export const TIER_0_WELCOME_HEADLINE = 'Start Earning Rewards';
export const TIER_0_HUB_ISSUE_SUBTEXT =
  "Before you can start earning rewards, you'll need to fix a few things on this machine.";
export const TIER_0_WELCOME_STATUS_LINE = 'This machine cannot currently earn rewards on the network.';
export const TIER_0_UNLOCK_ACCESS_CTA = 'How to unlock access';
export const TIER_0_WELCOME_UNLOCK_REWARDS_CTA = 'Unlock Rewards';
